import axios from "axios";
import { getIntegrationsOriginDomain, getTranslationsOriginDomain } from "../utils";
import { mainStore } from "../mainStore";

export const getSkin = async (gameId, skinName) => {
  const host = `${process.env.REACT_APP_INTEGRATION_BASE_URL}.${getIntegrationsOriginDomain()}`;
  const url = `${host}/api/v1/Skins/Resources/Values?GameId=${gameId}&SkinName=${skinName}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching skin:", error);
    throw error;
  }
};

const translationsApiUrl = `${process.env.REACT_APP_TRANSLATION_BASE_URL}.${getTranslationsOriginDomain()}/api/v1/Translations`;

export const getTranslations = async (applicationId, isoCode) => {
  try {
    const response = await axios.get(translationsApiUrl, {
      params: {
        ApplicationId: applicationId,
        IsoCode: isoCode,
      },
      headers: {
        Accept: "text/plain",
      },
    });

    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Request failed with status: " + response.status);
    }
  } catch (error) {
    throw new Error("An error occurred: " + error.message);
  }
};

export const getFreeBets = async (baseUrl, gameId) => {
  const response = await axios.get(`${baseUrl}/api/v1/FreeBets`, {
    params: { gameId },
    headers: { Authorization: `Bearer ${mainStore.accessToken}` },
  });

  return response.data.data;
};
